import { IRequirementCategoryModel } from '../../../../../../../service/requirement/category/IRequirementCategoryModel';
import { RowContextMenuUI } from '../../../../../../design/dataTable/parts/rowContextMenu/domain/RowContextMenuUI';
import { DefaultRowContextMenu } from '../../../../../../design/dataTable/parts/rowContextMenu/view/DefaultRowContextMenu';

export class RequirementCategoryAdminContextMenuUI<RowType> extends RowContextMenuUI<IRequirementCategoryModel> {
  constructor(contextDomain) {
    super(contextDomain);
    this.defaultContextMenu.setValue({
      Component: DefaultRowContextMenu,
      id: 'default',
      properties: {
        event: null,
        isOpened: false,
        row: null,
      },
    });
  }
}
